module.exports = __webpack_public_path__ + "static/media/icon-outline-navigate-white.33c44840.svg";